import { Container, withStyles } from '@material-ui/core';
import React, { useEffect } from "react";
import styles from "./styles";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";

import Breadcrumbs from "../../components/Breadcrumbs";
import * as generalActions from '../../actions/general';
import { SHARED_IMAGE_BASE_URL } from "../../constants/ui";
import Seo from "../../components/Seo";

function SharedDetail(props){
  const { classes, detailSharedAction, match, detailSharedState, seoData} = props;
  const { fetchSharedDetailAction } = detailSharedAction;

  useEffect(() => {
    const { alias } = match.params;
    fetchSharedDetailAction(alias);
  }, [fetchSharedDetailAction, match.params]);

  const mapParams = () => {
    let params = [{ name: 'Chia sẻ', cate: 'shared', to: '/shared'}];

    if(detailSharedState){
      params.push({
        name: detailSharedState.name,
        cate: "shared-child",
        to: detailSharedState.alias
      });
    }

    return params;
  }
  return (
    <>
      <Seo seoContent={detailSharedState && detailSharedState.seo_title !== null ? detailSharedState : seoData}/>
      <Breadcrumbs params={mapParams()}/>
      <Container className={classes.container} maxWidth="xl">
        <div className="title">
          <h2>{detailSharedState.name}</h2>
        </div>
        <div
          className={classes.desc}
          dangerouslySetInnerHTML={{ __html: detailSharedState.description }}
        />
        <img
          className={classes.img}
          alt="img"
          src={`${SHARED_IMAGE_BASE_URL}/${detailSharedState.picture}`}
        />
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{ __html: detailSharedState.content }}
        />
      </Container>
    </>
  );
}
const mapStateToProps = state => ({
  detailSharedState: state.general.detailShared 
});

const mapDispatchToProps = dispatch => {
  return {
    detailSharedAction: bindActionCreators(generalActions, dispatch)   
  }
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withStyles(styles), withConnect)(SharedDetail);